<template>
  <div
    :class="[
      'relative inline-block border rounded-full text-left',
      disabled
        ? 'border-neutral-200 cursor-not-allowed opacity-50'
        : 'border-neutral-400 hover:bg-gray-100'
    ]"
  >
    <button
      @click="toggle"
      :disabled="disabled"
      class="flex items-center gap-2 px-4 py-2 text-sm text-neutral-400 rounded-full disabled:cursor-not-allowed"
    >
      <component :is="icon" v-if="icon" class="w-4 h-4" />
      <span>{{ label }}</span>
      <span
        v-if="selectedCount > 0"
        class="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-primary30 text-white"
      >
        {{ selectedCount }}
      </span>
    </button>

    <div
      v-if="isOpen"
      @click.stop
      :class="[
        'absolute z-10 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 min-w-[240px] border border-neutral-200',
        alignRight ? 'right-0' : 'left-0',
        dropdownClass
      ]"
    >
      <div v-if="searchable" class="p-2 border-b">
        <input
          v-model="search"
          type="text"
          placeholder="Buscar..."
          class="w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
        />
      </div>

      <ul class="max-h-60 overflow-auto">
        <li
          v-for="option in filteredOptions"
          :key="option.value"
          @click="select(option)"
          :class="[
            'px-4 py-2 text-sm cursor-pointer',
            isSelected(option.value)
              ? 'bg-gray-100 font-semibold text-primary30'
              : 'text-gray-700 hover:bg-gray-100'
          ]"
        >
          {{ option.label }}
        </li>
        <li v-if="filteredOptions.length === 0" class="px-4 py-2 text-sm text-gray-400 italic">
          Nenhum resultado
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const props = defineProps<{
  isOpen: boolean
  label: string
  icon?: any
  options: { label: string; value: string }[]
  searchable?: boolean
  dropdownWidth?: string
  multiple?: boolean
  selectedValue?: string | string[] | null
  alignRight?: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'select', value: string): void
  (e: 'toggle'): void
}>()

const search = ref('')

function toggle() {
  if (props.disabled) return
  search.value = ''
  emit('toggle')
}

function select(option: { value: string }) {
  emit('select', option.value)
}

const selectedCount = computed(() => {
  if (!props.selectedValue) return 0
  if (Array.isArray(props.selectedValue)) return props.selectedValue.length
  return props.selectedValue ? 1 : 0
})

const filteredOptions = computed(() =>
  props.searchable
    ? props.options.filter((opt) => opt.label.toLowerCase().includes(search.value.toLowerCase()))
    : props.options
)

const dropdownClass = computed(() => (props.dropdownWidth ? props.dropdownWidth : 'w-48'))

function isSelected(optionValue: string): boolean {
  if (!props.selectedValue) {
    return false
  }
  if (props.multiple && Array.isArray(props.selectedValue)) {
    return props.selectedValue.includes(optionValue)
  }
  if (!props.multiple && typeof props.selectedValue === 'string') {
    return props.selectedValue === optionValue
  }
  return false
}
</script>
